
import http from './http.service';

export class VendorService {

    getVendorsWithImages() {
        return http.get('/vendors?hasimages=true').then(x => x.data.data);
    }

    updateVendorInformation(company) {
        return http.put('/vendors/' + company.id, company).then(x => x.data.data);
    }

    loadVendorsWithImages() {
        return http.get('/vendors?hasimages=true').then(response => response.data.data);
    }
}